const BaseView = require('components-framework/view/base.view');
const dpTracking = require('od-tracking/dynpack')('compressed_header');
const trackingUtils = require('od-modules/utils/tracking.utils');
const {getTotalPassengers} = require('od-modules/models/common/search_summary_utils.js');

const formatDateHeader = Odigeo._.partial(Odigeo.Utils.formatDate, _, Odigeo.SessionScope.websiteDateFormats.searchSummaryHeaderMobile);
const isDP = () => Odigeo.SessionScope.flowProduct === 'dp';

const showFlightSummary = () => {
    Odigeo.trigger('analytics:tracking', {
        type: 'trackEvent',
        data: {
            page: Odigeo.History.getPageNameFromFragment(),
            action: 'header',
            label: 'open_trip_details',
            appendPageLabel: true,
        },
    });
    Odigeo.trigger('searchsummary:clickDetails', !window.location.hash.includes('no_results'));
};

const toggleChangeSearch = () => {
    trackChangeSearch();
    Odigeo.trigger('results-search-summary:toggleChangeSearch');
    if (!isDP()) {
        Odigeo.trigger('results-remove-filters:showFilterBox', false);
    }
};

const onToggleUserAreaMenu = () => {
    Odigeo.trigger('prisma-header:toggleUserAreaMenu');
};

const onTapSupportAreaRightMenu = function(e) {
    const userInfo = this.model.get('userInfo');
    const of2UserData = this.model.get('of2UserData');
    if ($(e.target).hasClass('header_booking_button')
        || Odigeo.AB.getSupportAreaNewExperience === 3 && (!of2UserData.isLogged && !of2UserData.isToken)) {
        trackingUtils.trackEvent('header', 'sso_module', 'header_go_to_find_booking');
        Odigeo.Router.navigate('mytripslogin/actions=opensa');
    } else if (userInfo.isLogged) {
        Odigeo.trigger('prisma-header:toggleUserAreaMenu');
    } else {
        trackingUtils.trackEvent('header', 'sso_module', 'header_go_to_login');
        Odigeo.trigger('prisma-header:openLoginForm');
    }
};

const actionButtons = (currentPage) => {
    const goBackAction = () => {
        trackingUtils.trackEvent('header', 'back_button', currentPage);

        Odigeo.History.history.back();
    };
    const goBackFromWaitingSummary = () => {
        Odigeo.Device.getViewport().removeClass('od-viewport-no-vertical-scroll');
        goBackAction();
    };
    const backIcon = Odigeo.AB.isCssVariationMobile ? 'odf-icon-arrow-left-tail' : 'odf-icon-arrow-left';
    const pages = ['passengersinfo', 'payment', 'ancillaries', 'waiting_summary', 'membership'];
    pages.push('fare-rules');

    return {
        left: {
            pages,
            iconMap: {
                'passengersinfo': backIcon,
                'payment': backIcon,
                'ancillaries': backIcon,
                'fare-rules': backIcon,
                'waiting_summary': backIcon,
                'membership': backIcon,
            },
            actionMap: {
                'passengersinfo': goBackAction,
                'payment': goBackAction,
                'ancillaries': goBackAction,
                'fare-rules': goBackAction,
                'waiting_summary': goBackFromWaitingSummary,
                'membership': goBackAction,
            },
        },
        right: {
            iconMap: {
                'booking': 'odf-icon-edit',
                'dpresults_accommodation': 'odf-icon-edit',
                'dpresults_flights': 'odf-icon-edit',
                'fare-rules': isDP() ? 'odf-icon-shopping-cart' : 'odf-icon-information',
                'passengersinfo': isDP() ? 'odf-icon-shopping-cart' : 'odf-icon-information',
                'payment': isDP() ? 'odf-icon-shopping-cart' : '',
                'results': Odigeo.AB.isCssVariationMobile ? 'odf-icon-edit' : '',
                'waiting_summary': '',
                'flightsummary': Odigeo.AB.isCssVariationMobile ? 'odf-icon-edit' : '',
                'checkout_flight_summary_meta': 'odf-icon-edit',
                'home': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'sahome': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'btform': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'register': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'loginexpired': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'mytrips': 'odf-icon-user-area',
                'tripdetails': 'odf-icon-user-area',
                'membership_mytrips_reactivation': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'membership_retention': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'membership_cancellation': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'membership_cancellation_request': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'right_of_withdrawal': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'remediation_request': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'remediation_process': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'frequentpassengers': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'accountpreferences': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
                'accountcreditcards': Odigeo.AB.isNewUserMenuV2Mobile ? 'odf-icon-user-area' : '',
            },
            actionMap: {
                'booking': toggleChangeSearch,
                'dpresults_accommodation': toggleChangeSearch,
                'dpresults_flights': toggleChangeSearch,
                'fare-rules': showFlightSummary,
                'passengersinfo': showFlightSummary,
                'payment': isDP() ? showFlightSummary : Function.prototype,
                'results': Odigeo.AB.isCssVariationMobile ? toggleChangeSearch : () => {},
                'waiting_summary': () => {},
                'flightsummary': Odigeo.AB.isCssVariationMobile ? toggleChangeSearch : () => {},
                'checkout_flight_summary_meta': toggleChangeSearch,
                'home': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'sahome': Odigeo.AB.isNewUserMenuV2Mobile ? onTapSupportAreaRightMenu : () => {},
                'btform': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'register': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'loginexpired': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'mytrips': onToggleUserAreaMenu,
                'tripdetails': onToggleUserAreaMenu,
                'membership_mytrips_reactivation': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'membership_retention': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'frequentpassengers': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'accountpreferences': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
                'accountcreditcards': Odigeo.AB.isNewUserMenuV2Mobile ? onToggleUserAreaMenu : () => {},
            },
        },
    };
};

const trackChangeSearch = () => {
    if (isDP()) {
        dpTracking.click();
    } else {
        trackingUtils.trackEvent('searcher_flights', 'open_change_search');
    }
};

module.exports = BaseView.extend({
    events: {
        'tap .prisma_header_summary': 'onSummaryClick',
        'tap .pax_header_open_summary': 'onHeaderClick',
        'tap .right_action_icon': 'onRightActionClick',
        'tap .left_action_icon': 'onLeftActionClick',
    },
    selectors: {
        headerSummary: '.prisma_header_summary',
        rightActionIcon: '.right_action_icon',
        rightSupportAction: '.support_area_action',
        leftActionIcon: '.left_action_icon',
        leftHomeAction: '.prisma_home_button',
    },

    toggleChangeSearch: toggleChangeSearch,

    onSummaryClick() {
        const pagesWhereActive = ['results', 'dpresults_accommodation', 'dpresults_accommodation_details', 'dpresults_flights'];

        if ( Odigeo.AB.isCssVariationMobile ) {
            pagesWhereActive.push('flightsummary');
        }

        if (Odigeo._.includes(pagesWhereActive, this.model.get('page'))) {
            this.toggleChangeSearch();
        }
    },

    onLeftActionClick(e) {
        const page = this.model.get('page');
        if (page === 'passengersinfo') {
            Odigeo.trigger(this.id + ':goBackPopup');
            trackingUtils.trackEvent('header', 'go_back_arrow');
        } else {
            this.onActionClick(e, 'left');
        }
    },

    onRightActionClick(e) {
        trackingUtils.trackEvent('searcher_flights', 'click_change_search-pos:header');
        const page = this.model.get('page');
        if (!Odigeo.AB.isEditSearch || this.model.get('trainSearch') || page !== 'results') this.onActionClick(e, 'right');
    },

    onHeaderClick(e) {
        this.onActionClick(e, 'right');
    },

    onActionClick(e, btn) {
        e.stopPropagation();
        e.preventDefault();

        const currentPage = this.model.get('page');

        const buttonConfiguration = actionButtons(currentPage)[btn];

        buttonConfiguration.actionMap[currentPage].call(this, e);
    },

    initialize() {
        this.listenTo(this.model, 'change', this.render);
    },

    render() {
        const currentPage = this.model.get('page');
        this.renderRightButtons(currentPage);
        this.renderLeftButtons(currentPage);
    },

    parseViewModel() {
        const jsonModel = this.model.toJSON();
        return Object.assign({}, jsonModel, {
            originCityName: jsonModel.cityNames.originCityName,
            destinationCityName: jsonModel.cityNames.destinationCityName,
            originIata: jsonModel.iatas.originIata,
            destinationIata: jsonModel.iatas.destinationIata,
            paxTotal: getTotalPassengers.call(this),
            dateBegin: formatDateHeader(jsonModel.dates[0]),
            dateEnd: jsonModel.dates[1] ? formatDateHeader(jsonModel.dates[1]) : null,
            isDP: isDP(),
        });
    },

    renderRightButtons(currentPage) {
        const rightButtonConfiguration = actionButtons(currentPage).right;

        let rightButtonTemplate;
        switch (currentPage) {
            case 'flightsummary':
            case 'checkout_flight_summary_meta':
            case 'results':
                if ( Odigeo.AB.isCssVariationMobile ) {
                    rightButtonTemplate = this.templates.rightActionButtonV2;
                }
                break;
            case 'fare-rules':
                rightButtonTemplate = Odigeo.AB.isFarePlusInjectionOF2Mobile
                    ? this.templates.rightActionDetails
                    : this.templates.rightActionButton;
                break;
            case 'passengersinfo':
                rightButtonTemplate = this.templates.rightActionDetails;
                break;
            case 'home':
            case 'register':
            case 'loginexpired':
            case 'membership_mytrips_reactivation':
            case 'membership_retention':
            case 'membership_cancellation':
            case 'membership_cancellation_request':
            case 'right_of_withdrawal':
            case 'remediation_request':
            case 'remediation_process':
            case 'frequentpassengers':
            case 'accountpreferences':
            case 'accountcreditcards':
            case 'btform':
                if (Odigeo.AB.isNewUserMenuV2Mobile) {
                    rightButtonTemplate = this.templates.rightActionButtonLogin;
                }
                break;
            case 'tripdetails':
            case 'mytrips':
                rightButtonTemplate = this.templates.rightActionMenuOf2;
                this.$el.off('tap .right_action_icon');
                break;
            case 'sahome':
                if (Odigeo.AB.getSupportAreaNewExperience === 3) {
                    if (this.model.get('of2UserData')) {
                        rightButtonTemplate = this.templates.rightActionButtonSahomeC;
                    }
                } else if (Odigeo.AB.isNewUserMenuV2Mobile) {
                    rightButtonTemplate = this.templates.rightActionButtonSahome;
                }
                break;
            default:
                rightButtonTemplate = this.templates.rightActionButton;
        }

        const rightButtonHtml = rightButtonTemplate && Object.keys(rightButtonConfiguration.actionMap).includes(currentPage)
            ? rightButtonTemplate({keys: this.keys, icon: rightButtonConfiguration.iconMap[currentPage], userInfo: this.model.get('userInfo'),
                isMultidestination: this.model.get('isMultidestination'), trainSearch: this.model.get('trainSearch')})
            : '';
        this.$el.find(this.selectors.rightActionIcon).html(rightButtonHtml);
    },

    renderLeftButtons(currentPage) {
        const leftButtonConfigurations = actionButtons(currentPage).left;
        if ( leftButtonConfigurations.pages.includes(currentPage) && Odigeo.AB.isCssVariationMobile ) {
            this.$el.find(this.selectors.leftActionIcon)
                .html(this.templates.leftActionButton({keys: this.keys, icon: leftButtonConfigurations.iconMap[currentPage]}));
            this.$el.find(this.selectors.leftHomeAction).toggleClass('odf-hidden', true);
        } else {
            this.$el.find(this.selectors.leftActionIcon).empty();
            this.$el.find(this.selectors.leftHomeAction).toggleClass('odf-hidden', false);
        }

        let cobaltPrismaHeader4thIteration = false;
        const isSecure = this.$el.find(this.selectors.headerSummary).data('secure') === true;
        let isSummaryBackgroundByPage = !Odigeo.AB.isCssVariationMobile && !isSecure;

        switch (currentPage) {
            case 'flightsummary':
            case 'results':
                cobaltPrismaHeader4thIteration = Odigeo.AB.isCssVariationMobile;
                break;
            default:
                cobaltPrismaHeader4thIteration = false;
        }

        if (this.model.get('dates') !== null ) {
            this.$el.find(this.selectors.headerSummary)
                .html(this.templates.flightSummary(Odigeo._.extend(
                    this.parseViewModel(),
                    {
                        keys: this.keys,
                        isSummaryBackgroundByPage,
                        cobaltPrismaHeader4thIteration,
                    }
                )));
            if (isSummaryBackgroundByPage && Odigeo.AB.isCssVariationMobile) {
                this.$el.find(this.selectors.headerSummary)
                    .toggleClass('odf-header-mobile-search-bg', isSummaryBackgroundByPage);
            }
        }
    },
});
